<template>
  <sidebar-items-list
      :api-url="apiUrl"
      :back-to="{ name: 'projects.index' }"
      :header="$t('Components')"
      model-type="component"
      show-clone-options
  />
</template>
<script>
import SidebarItemsList from "@/components/SidebarItemsList";

export default {
  name: 'Components',
  components: {SidebarItemsList},
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/components`;
    },
  },
};
</script>
